import styled from 'styled-components';
import storeBg from '../../../assets/storebg.png';

// export const MobileDashboardSection = styled.section`
//     width: 95%;
//     padding-bottom: 4rem;
//     padding-top: 1rem;
//     @media screen and (max-width: 500px) {
//         width: 100%;
//         padding-bottom: 4rem;
//         padding-top: 1rem;
//     }
// `;

// export const DashboardSection = styled.section`
//     width: 90%;
//     padding-bottom: 4rem;
//     padding-top: 1rem;
//     /* margin: auto; */
//     margin-right: auto;
// `;
// export const ImportSection = styled.section`
//     width: 95%;
//     padding-bottom: 4rem;
//     padding-top: 1rem;

//     @media screen and (max-width: 500px) {
//         width: 100%;
//         height: 80vh;
//     }
// `;

// export const StoreSection = styled.section`
//     width: 100%;
//     height: 90vh;
//     padding: 4rem;

//     .BannerImg {
//         height: 40%;
//         border: 1px solid;
//         background-image: url(${storeBg});
//         background-repeat: no-repeat;
//         background-size: cover;
//         svg {
//             path {
//                 stroke: white;
//             }
//         }
//     }
//     @media screen and (max-width: 500px) {
//         width: 100vw;
//         height: 100vh;

//         .BannerImg {
//             height: 65%;
//         }
//     }
// `;
// export const OrderSection = styled.section`
//     width: 85%;
//     height: 100%;
//     @media screen and (max-width: 500px) {
//         width: 100vw;
//         height: 100vh;
//     }
// `;

export const InvoiceSection = styled.section`
    width: 85%;
    height: 100%;
    padding: 3rem;
    padding-top: 5rem;
    @media screen and (max-width: 500px) {
        width: 100vw;
        height: 100vh;
    }
`;

export const MobileDashboardSection = styled.section`
    width: 95%;
    padding-bottom: 4rem;
    padding-top: 1rem;
    @media screen and (max-width: 500px) {
        width: 100%;
        padding-bottom: 4rem;
        padding-top: 1rem;
    }
`;

export const DashboardSection = styled.section`
    width: 95%;
    padding-bottom: 4rem;
    padding-top: 1rem;
    margin: 0 auto;
`;
export const ImportSection = styled.section`
    width: 95%;
    padding-bottom: 4rem;
    padding-top: 1rem;

    @media screen and (max-width: 500px) {
        width: 100%;
        height: 80vh;
    }
`;

export const ProductDetailsSection = styled.section`
    width: 100%;
    padding-bottom: 4rem;
    padding-top: 1rem;

    @media screen and (max-width: 500px) {
        width: 100%;
        height: 80vh;
    }
`;

export const StoreSection = styled.section`
    width: 90%;
    margin: 0 auto;

    .BannerImg {
        height: 40%;
        border-radius: 10px;
        background-image: url(${storeBg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        svg {
            path {
                stroke: white;
            }
        }
    }
    @media screen and (max-width: 500px) {
        height: 100vh;

        .BannerImg {
            height: 65%;
        }
    }
`;
export const OrderSection = styled.section`
    width: 95%;
    height: 100%;
    @media screen and (max-width: 500px) {
        width: 100vw;
        height: auto;
    }
`;

export const MyTransactionsSection = styled.section`
    width: 85%;
    height: 100%;
    @media screen and (max-width: 500px) {
        width: 100vw;
    }
`;

export const TransactionsContainer = styled.div`
    width: 100%;
    border: 1px solid #ececec;
    border-radius: 8px;
    margin-top: 2rem;
    width: 100%;
    overflow-x: auto;
    @media screen and (max-width: 500px) {
        width: 100vw;
    }
`;

export const TableHeader = styled.div`
    display: grid;
    grid-template-columns: 15% 25% 15% 13% 18% 7% 7%;
    background-color: #f1f1f4;
    padding: 15px 0px 15px 20px;
    width: 100%;
    white-space: no-wrap;
`;

export const TableContent = styled.div`
    display: grid;
    grid-template-columns: 15% 25% 15% 13% 18% 7% 7%;
    padding: 15px 0px 15px 20px;
`;

export const TableContentNoCoulmn = styled.div`
    padding: 15px 0px 15px 20px;
    text-align: center;
    width: 100%;
`;

export const DesktopContainer = styled.section`
    display: none;
    @media screen and (min-width: 850px) {
        display: block;
    }
`;

export const MobileContainer = styled.section`
    display: block;
    @media screen and (min-width: 850px) {
        display: none;
    }
`;

export const BrandsSection = styled.section`
    width: 95%;
    padding-top: 1rem;
    margin: 0 auto;
`;
